export default __webpack_public_path__ + "static/media/crops.a3dd5a04.png";